// extracted by mini-css-extract-plugin
module.exports = {"thankYouQueueModal":"_2jZmsf","container":"KTwLLm","countdown":"_2eqYJ5","logo":"_2VDq5g","digits":"v9rQaS","button":"_2nppNk"};